import { render, staticRenderFns } from "./TheHeaderQuestions.vue?vue&type=template&id=44b5dba4&scoped=true&lang=pug&"
import script from "./TheHeaderQuestions.vue?vue&type=script&lang=js&"
export * from "./TheHeaderQuestions.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderQuestions.vue?vue&type=style&index=0&id=44b5dba4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5dba4",
  null
  
)

export default component.exports